// Footer translations
const footerTranslations = {
  en: {
    footerPartners: "along the way / selected collaborators / some remain confidential.",
    brandTagline: "independent / creative / technology",
    navigate: "01 / navigate",
    capabilities: "02 / capabilities",
    connect: "03 / connect",
    legal: {
      disclaimer: "impressum / disclaimer",
      privacy: "datenschutzerklärung / privacy policy",
      accessibility: "accessibility"
    },
    social: {
      instagram: "Instagram",
      linkedin: "LinkedIn",
      discord: "Discord",
      github: "GitHub"
    },
    socialAriaLabels: {
      instagram: "thewhizkind on Instagram (opens in new tab)",
      linkedin: "Prayrit Singh on LinkedIn (opens in new tab)",
      discord: "Prayrit Singh on Discord (opens in new tab)",
      github: "Prayrit Singh on GitHub (opens in new tab)"
    },
    footerLinks: {
      /*01 / navigate*/
      services: "services",
      lab: "lab",
      gallery: "gallery",
      about: "about",
      contact: "contact",
      principles: "principles",
      /*02 / capabilities*/
      brandAndIdentity: "branding & identity",
      webDevelopment: "web development",
      graphicDesign: "graphic design",
      aiAndAutomation: "ai & automation",
      communication: "communication",
      digitalisation: "digitalisation",
      creativeDevelopment: "creative development",
      processOptimisation: "process optimisation"
    }
  },
  de: {
    footerPartners: "am arbeitsweg / ausgewählte partner / manche bleiben vertraulich.",
    brandTagline: "unabhängig / kreativ / technikaffin",
    navigate: "01 / navigation",
    capabilities: "02 / fähigkeiten",
    connect: "03 / verbinden",
    legal: {
      disclaimer: "impressum / haftungsausschluss",
      privacy: "datenschutzerklärung / privatsphäre",
      accessibility: "barrierefreiheit"
    },
    social: {
      instagram: "Instagram",
      linkedin: "LinkedIn",
      discord: "Discord",
      github: "GitHub"
    },
    socialAriaLabels: {
      instagram: "thewhizkind auf Instagram (wird in neuem tab geöffnet)",
      linkedin: "Prayrit Singh auf LinkedIn (wird in neuem tab geöffnet)",
      discord: "Prayrit Singh auf Discord (wird in neuem tab geöffnet)",
      github: "Prayrit Singh auf GitHub (wird in neuem tab geöffnet)"
    },
    footerLinks: {
      /*01 / navigate*/
      services: "dienstleistungen",
      lab: "werkstatt",
      gallery: "galerie",
      about: "über uns",
      contact: "kontakt",
      principles: "prinzipien",
      /*02 / capabilities*/
      brandAndIdentity: "markenbildung & corporate identity",
      webDevelopment: "webentwicklung",
      graphicDesign: "grafikdesign",
      aiAndAutomation: "ki & automatisierung",
      communication: "kommunikation",
      digitalisation: "digitalisierung",
      creativeDevelopment: "kreative entwicklung",
      processOptimisation: "prozessoptimierung"
    }
  }
};

export default footerTranslations;